<script setup>
import DiscountCategoryGrid from '@/components/registry/DiscountCategoryGrid.vue'
</script>
<template>
  <discount-category-grid />
</template>
